window.$ = window.jQuery = require('jquery');

require('bootstrap-sass');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

window.moment = require('moment');
require('bootstrap-colorpicker');


require('./modules/confirm.js');
require('./modules/datetimepicker.js');
require('./modules/placeholder.js');
require('./modules/toastr.js');
require('./modules/colorpicker.js');
require('./modules/cookie.js');

require('fancybox')(window.jQuery);
require('owl.carousel');
require('fullcalendar');
require('datatables.net');
require('datatables.net-fixedcolumns-bs');

if(document.querySelector('#chartsSection')) {
    var Chart = require('chart.js');
    require('./modules/charts/createChart');
    require('./modules/charts/datepickers');
    require('./modules/charts/createPdfForm');
}

if (document.querySelector('.js-UserFormController')) {
    new (require('./modules/UserFormController'))();
}

if(document.querySelector('#js-expenditure-jstree')) {
	require('./modules/expenditures/expenditure_tree');
}

if(document.querySelector('#js-profit-and-loss-create')) {
	new (require('./modules/finances/ProfitAndLossController'))();
}

if (document.querySelector('.js-employment-history')) {
    require('./modules/employment-history/employment-history');
}

if (document.querySelector('.js-show-hide')) {
    require('./modules/showHideElements');
}

if (document.querySelector('.js-show-hide-clause')) {
    require('./showHideClause');
}

if (document.querySelector('#employmentHistoryModal')) {
    require('./modules/employment-history/show');
}

if (document.querySelector('#add-client-contact')) {
    require('./modules/clients/add_client_contact.js');
}

if (document.querySelector('.js-payment-module')) {
    require('./modules/payment.js');
}

if (document.querySelector('.scrollHere')) {
    require('./modules/scrollHere.js');
}

if (document.querySelector('.sameHeight')) {
    require('./modules/sameHeight.js');
}

if (document.querySelector('.js-iir-rooms')) {
    require('./iir-rooms.js');
}

if (document.querySelector('.js-ignore-monthly-inspection-checkbox')) {
	require('./modules/inspections/ignore_monthly_inspection.js');
}

if (document.querySelector('.available-space-js-photo')) {
    require('./change-main-image.js');
}

if (document.querySelector('.js-select-head-guardian')) {
    require('./room-select-head-guardian.js');
}

if (document.querySelector('#js-monthly-inspection-report-meters-form')) {
    require('./monthly-inspection-report-meters-form.js');
}

if (document.querySelector('#js-monthly-inspection-report-checklist')) {
    require('./monthly-inspection-report-add-space.js');
}

if (document.querySelector('.js-mir-checklist')) {
    require('./monthly-inspection-report-checklist.js');
}

if (document.querySelector('.js-request-viewing-ajax')) {
    require('./modules/property_viewings/request_viewing.js');
}

if (document.querySelector('#js-rooms-sortable')) {
    require('jquery-ui');
    require('jquery-ui/ui/widgets/sortable.js')
    require('./rooms-sortable.js');
}

if (document.querySelector('#property-documents')) {
    require('jquery-ui');
    require('jquery-ui/ui/widgets/sortable.js');
}

if (document.querySelector('.js-property-documents') ) {
    require('./modules/documents/property-documemts.js');
}

if (document.querySelector('#datatable-all-guardians')) {
    require('./guardians-emailed-or-phoned.js');
}

if (document.querySelector('.js-guardians-update-field') ) {
    require('./guardians-update-field.js');
}

if (document.querySelector('.js-budget-update-field') ) {
    require('./budget-update-field.js');
}

if (document.querySelector('.js-budget-create-new') ) {
    require('./budget-create-new.js');
}

if (document.querySelector('#js-vip-due-date') ) {
    require('./vip-due-date.js');
}

if (document.querySelector('.js-property-update-field')) {
	require('./property-update-field.js');
}

if (document.querySelector('.js-client-update-field') || document.querySelector('.js-client-update-field-text')) {
	require('./client-update-field.js');
}

if (document.querySelector('.js-select-main-contact')) {
    require('./client-select-main-contact.js');
}

if (document.querySelector('.js-tickets-dt')) {
    require('./datatables/tickets/checkboxes.js');
}

if (document.querySelector('#js-email-attachments') || document.querySelector('.js-email-attachments')) {
    require('./multiple-email-attachments.js');
}

if (document.querySelector('#js-ticket-attachments')) {
    require('./multiple-ticket-attachement.js');
}

if (document.querySelector('.js-guardian-resources')) {
    require('./guardian-resources.js');
}

if (document.querySelector('#js-rooms-of-property-effect')) {
    require('./rooms-animation-effect.js');
}

if (document.querySelector('#js-rooms-typeahead')) {
    require('./rooms-guardians-assign-typeahead.js');
}

if (document.querySelector('#js-assign-guardian-form')) {
    require('./assign-guardian-typeahead.js');
}

if (document.querySelector('#js-properties-typeahead')) {
    require('./properties-typeahead.js');
}

if (document.querySelector('.js-users-typeahead')) {
	require('./users-typeahead.js');
}

if (document.querySelector('#js-property-viewings-add-viewings')) {
    require('./modules/property_viewings/add_property_viewings_typeahead.js');
}

if (document.querySelector('.js-property-viewings-add-guardians')) {
    require('./modules/property_viewings/add_guardians_viewings_typeahead.js');
}

if (document.querySelector('#js-inspections-add-many')) {
	require('./modules/inspections/add_many.js');
}

if (document.querySelector('#js-add-multiple-expenditures')) {
    require('./modules/expenditures/add_expenditures_typeahead.js');
}

if (document.querySelector('#js-add-many-expenses')
    || document.querySelector('.js-expense-account-typeahead')) {
	require('./modules/expenditures/add_many_expenses.js');
}

if (document.querySelector('#js-expenditures-void-button')) {
    require('./modules/expenditures/void_button.js');
}

if (document.querySelector('#js-add-property-to-block')) {
    require('./modules/blocks/add_property_to_block.js');
}

if (document.querySelector('#js-add-property-to-inspection-route')) {
	require('./modules/inspection_routes/add_property_to_inspection_route.js');
}

if (document.querySelector('#js-rooms-search-helper')) {
    require('./rooms-search-helper.js');
}

if (document.querySelector('#guardian-description')) {
    require('./guardian-descriptions.js');
}

if (document.querySelector('#ticket-description')) {
    require('./tickets-descriptions.js');
}

if (document.querySelector('#js-submit-ticket-form')) {
    require('./create-ticket-typeahead-properties.js');
}

if (document.querySelector('#js-populate-ticket-dropdowns')) {
    require('./create-ticket-typeahead-contractors.js');
}

if (document.querySelector('#js-populate-client-contacts')) {
    require('./client-contacts-typeahead.js');
}

if (document.querySelector('.js-select-checkboxes')) {
    require('./modules/selectCheckboxes.js');
}

if (document.querySelector('#js-employment-history-checkbox')) {
    require('./employment-history-fields-checkbox.js');
}

if (document.querySelector('.js-tooltip')) {
    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });
}

if (document.querySelector('.js-edit-room')) {
    require('./rooms-edit.js');
}

if (document.querySelector('.js-run-modal-validation')) {
    require('./modal-validation.js');
}

if (document.querySelector('#js-run-image-rotate')) {
    require('./components/file/rotatable_image.js');
}

if (document.querySelector('#prevent-multiple-requests')) {
    new (require('./modules/PreventSendingMultipleRequestsController'))();
}

if (document.querySelector('#js-run-expenditures-form-on-properties')) {
    require('./expenditures-forms-on-properties.js');
}

if (document.querySelector('#js-run-expenditures-form-on-categories')) {
    require('./expenditures-forms-on-categories.js');
}

if (document.querySelector('.js-send-email-to-guardians-of-block')) {
    require('./send-emails-to-guardians-of-block.js');
}

if (document.querySelector('#generate_geo_codes_from_postcode')) {
	require('./generate-geo-codes-from-postcode.js').default;
}

if (document.querySelector('.js-e-sign-document')) {
	require('./modules/rents/sign_document.js');
}

if (document.querySelector('#vip_provided_set_rule')) {
    require('./modules/properties/vip_set_rule.js');
}

if (document.querySelector('#add_proposed_work')) {
    require('./modules/properties/property_proposal_works.js');
}

if (document.querySelector('#property_proposal')) {
    require('./modules/properties/property_proposal.js');
}

if (document.querySelector('#show-ntq-document')) {
    require('./modules/rents/show_ntq_document.js');
}

if (document.querySelector('#js-report-with-daterange')) {
    require('./modules/reports/report_with_daterange.js')
}

if (document.querySelector('#js-add-petty-cash')) {
    require('./modules/petty_cash/add_many.js');
}

if (document.querySelector('#js-rent-ntq')) {
    require('./modules/rents/rent-ntq.js');
}

if (document.querySelector('.js-pettycash-typeahead')) {
    require('./modules/petty_cash/add_many_typeahead.js');
}

if (document.querySelector('.js-toggle-guardian-fields')) {
    require('./toggle_guardian_fields.js');
}

if (document.querySelector('.js-ticket-isComplaint')) {
    require('./ticket_is_complaint.js');
}

if (document.querySelector('.js-services-visibility')) {
    require('./services_visibility');
}

if (document.querySelector('.js-select-gender')) {
    require('./select-guardian-gender.js');
}

if(document.querySelector('#googleReviewPopup')) {
    $(document).ready(function(){ 
       // $("#googleReviewPopup").modal('show');
       
         // if the cookie doesn't exist create it and show the modal 
      
          //call the reveal modal 
          var delay=3000;
        
          setTimeout(function(){ $("#googleReviewPopup").modal('show'); },delay); 
     
    

    });
    
}



/**
 * Data table loader
 */
require('./datatables/table-loader');
require('./fancy.js');
require('./owlcarousel.js');
require('./properties-fullAddressCopy');

$(function () {

    if (document.querySelector('.js-property-viewing-of-property')) {
        require('./modules/property_viewings/property_viewing_property');
    }

    if (document.querySelector('.js-property-viewing-of-user')) {
        require('./modules/property_viewings/property_viewing_user');
    }

    if (document.querySelector('.js-tickets-of-member')) {
        require('./modules/tickets/tickets_member');
    }

	if (document.querySelector('.js-tickets-calendar')) {
		require('./modules/tickets/tickets_calendar');
	}

    if (document.querySelector('.js-tickets-of-contractor-contact')) {
        require('./modules/tickets/tickets_contractor_contact');
    }

	if (document.querySelector('.js-inspection-of-property')) {
		require('./modules/inspections/inspection_property');
	}

	if (document.querySelector('.js-inspection-of-building-manager')) {
		require('./modules/inspections/inspection_building_manager');
	}

	$('.not-clickable').on('click', function(e){
	    e.preventDefault();
    });

    $('.datepicker').datepicker({format: 'dd/mm/yyyy'});
});

require('./new/menu');
